// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__AGNmO","checkboxCol":"Table_checkboxCol__1ie8B","emailCol":"Table_emailCol__FFbnw","actionCol":"Table_actionCol__2xOdw"};